import React from 'react'
import styled from 'styled-components'
import { Card } from 'react-bootstrap'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import ColSpacer from '../../../common/styles/ColSpacer'
import AppUserResponse from '../AppUserResponse'
import BooksitoutImages from '../../../images/BooksitoutImages'
import BooksitoutIcon from '../../../config/BooksitoutIcon'
import Spacer from '../../../common/Spacer'
import BookStreakCard from '../../book/streak/BookStreakCard'
import useBookStreak from '../../book/streak/useBookStreak'
import RowSpacer from '../../../common/styles/RowSpacer'
import { Link } from 'react-router-dom'
import useDetectOS from '../../library/useDetectOS'

const ProfileUserCard: React.FC<{ user: AppUserResponse; isClickable: boolean }> = ({ user, isClickable }) => {
	const [streakCount, isTodayDone, isStreakLoading] = useBookStreak(user.urlName)

	return (
		<div className={'row'}>
			<div className={'col-12 col-md-8 col-xl-9'}>
				{isClickable ? (
					<a href={`/users/${user.urlName}`}>
						<UserCard user={user} />
					</a>
				) : (
					<UserCard user={user} />
				)}
			</div>

            <span className={'d-md-none'}>
                <RowSpacer />
            </span>

			<div className={'col-12 col-md-4 col-xl-3'}>

				<Card className={'h-100'}>
					<CardBodyContentContainer>
						<BookStreakCard streakCount={streakCount} isTodayDone={isTodayDone} isLoading={isStreakLoading} />
					</CardBodyContentContainer>
				</Card>
			</div>
		</div>
	)
}

const UserCard: React.FC<{ user: AppUserResponse }> = ({ user }) => {
	const { isIOS } = useDetectOS()

	const handleShare = async () => {
		try {
			await navigator.share({
				title: document.title,
				url: window.location.href,
			})
		} catch (err) {
			const msg = String(err?.message || '')
			const name = String(err?.name || '')
			const isCanceled = name === 'AbortError' || msg.includes('AbortError')

			if (isCanceled) return

			await handleCopy()
		}
	}

	const handleCopy = async () => {
		const url = window.location.href
		try {
			await navigator.clipboard.writeText(url)
			alert('주소가 복사되었습니다.')
		} catch {
			alert('주소 복사에 실패했습니다.')
		}
	}

	return (
		<Card>
			<CardBodyContentContainer>
				<ProfileContainer>
					<Flex>
						{user.profileImageUrl != null ? <ProfileImage src={user.profileImageUrl} alt={user.name} onError={(e) => e.target.src = BooksitoutImages.Placeholder.user} /> : <ProfileImage src={BooksitoutImages.Placeholder.user} alt={user.name} />}

						<ColSpacer />

						<div>
							<ProfileName>{user.name}</ProfileName>

							<ProfileDate>
								{user.registeredDate[0]}년 {user.registeredDate[1]}월 {user.registeredDate[2]}일
							</ProfileDate>
						</div>
					</Flex>

					<Spacer />

					<div
						className={''}
						onClick={e => {
							e.preventDefault()
						}}
					>
						{user.isMe && (
							<Link to="/settings/profiles" className={'text-book block'}>
								<BooksitoutIcon.settings style={{ fontSize: '26px' }} />
							</Link>
						)}
						{isIOS ? (
							<button type="button" className={'text-book block border-0 bg-transparent'} onClick={handleShare}>
								<BooksitoutIcon.share style={{ fontSize: '28px' }} />
							</button>
						) : (
							<button type="button" className={'text-book block border-0 bg-transparent inline-block'} onClick={handleCopy}>
								<BooksitoutIcon.copy style={{ fontSize: '28px' }} />
							</button>
						)}
					</div>
				</ProfileContainer>
			</CardBodyContentContainer>
		</Card>
	)
}

const Flex = styled.div`
	display: flex;
`

const ProfileContainer = styled.div`
	display: flex;
`

const ProfileName = styled.h1`
	font-size: 1.5rem;
	font-weight: bold;
`

const ProfileDate = styled.h1`
	font-size: 1rem;
	color: var(--sub-text-color);
`

const ProfileImage = styled.img.attrs({
	className: 'rounded',
})`
	width: 80px;
	height: 80px;
`

export default ProfileUserCard
